// This module is intended for text that either only consist of a few words,
// and/or can be dynamically generated without requiring template literals.
// This includes buttons, labels, static text (headers, etc), placeholders, etc.
// Anything not requiring translation will typically just be a function that lives
// here and doesn't use the formatter or translater modules.
// A few function names are quoted because they're reserved words.
// Formatter args:
// 1: Required.  Key(s) you wanna translate.  Pass single value or array.
// 2: Optional.  String representing type of message you want returned: 
// add, edit, search, select, message.
// Null type will just do basic translation.  This is the typical case for buttons,
// labels, headers, etc.
// 3: Optional.  Text you want included in the message, like names,
// counts or other static values.  Pass single value or array.
// 4: Optional.  Text is returned exactly as entered (after any applicable translation).
const F = require('./formatter');

module.exports = {
    helpDocument: () => F('help-document'),
    includeDeletedSteps: () => F('include-deleted-steps'),
    rejected: () => F('rejected'),
    approved: () => F('approved'),
    pending: () => F('pending'),
    deleteAllAccess: () => F('delete-all-access'),
    templateCriteria: () => F('template-criteria'),
    template: () => F('template'),
    wellFlags: () => F('well-flags'),
    wellName: () => F('well-name'),
    showEntryTypeWithoutNotifications: () => F('show-entry-types-without-notifications'),
    showEntryTypeTitle: () => F('show-entry-types-title'),
    showEntryTypeWithNotifications: () => F('show-entry-types-with-notifications'),
    showEntryTypeAll: () => F('show-entry-types-all'),
    send: () => F('send'),
    resendText: () => F('resend-text'),
    resendEmail: () => F('resend-email'),
    activity: () => F('activity'),
    viewNoMatterWhoUploadsIt: () => F('view-no-matter-who-uploads-it'),
    viewOnlyIfTheyUploadIt: () => F('view-only-if-they-upload-it'),
    roleType: () => F('role-type'),
    lastPasswordChangeDate: () => F('last-password-change-date'),
    lastLoginDate: () => F('last-login-date'),
    size: () => F('size'),
    entry: () => F('entry'),
    deletedBy: () => F('deleted-by'),
    deletedOn: () => F('deleted-on'),
    profile: () => F('profile'),
    mobile: () => F('mobile'),
    contactAndMessageDelivery: () => F('contact-and-message-delivery'),
    subscription: () => F('subscription'),
    editSubscribers: () => F('subscribers', 'edit'),
    addSubscribers: () => F('subscribers', 'add'),
    column: () => F('column'),
    wellProperty: () => F('well-property'),
    wellProperties: () => F('well-properties'),
    width: () => F('width'),
    addColumn: () => F('column', 'add'),
    onlyShowActiveRigs: () => F('only-show-active-rigs'),
    subAssets: () => F('sub-assets'),
    sortOrder: () => F('sort-order'),
    custom: () => F('custom'),
    direction: () => F('direction'),
    sortBy: () => F('sort-by'),
    addSort: () => F('sort', 'add'),
    publish: () => F('publish'),
    fileType: () => F('file-type'),
    sort: () => F('sort'),
    mon: () => F('mon'),
    tue: () => F('tue'),
    wed: () => F('wed'),
    thu: () => F('thu'),
    fri: () => F('fri'),
    sat: () => F('sat'),
    sun: () => F('sun'),
    daysOfTheMonth: () => F('days-of-the-month'),
    daysOfTheWeek: () => F('days-of-the-week'),
    daysOfReportDelivery: () => F('days-of-report-delivery'),
    timeZone: () => F('time-zone'),
    time: () => F('time'),
    timeOfReportDelivery: () => F('time-of-report-delivery'),
    scheduled: () => F('scheduled'),
    delivery: () => F('delivery'),
    fontSize: () => F('font-size'),
    compressed: () => F('compressed'),
    tableHeaders: () => F('table-headers'),
    rich: () => F('rich'),
    format: () => F('format'),
    beneath: () => F('beneath'),
    beside: () => F('beside'),
    layout: () => F('layout'),
    reportFormat: () => F('report-format'),
    days: () => F('days'),
    hours: () => F('hours'),
    setRange: () => F('set-range'),
    dateRange: () => F('date-range'),
    recurringRange: () => F('recurring-range'),
    daysOnReport: () => F('days-on-report'),
    sorting: () => F('sorting'),
    newestVersionOnly: () => F('newest-version-only'),
    addEntryType: () => F('entry-type', 'add'),
    new: () => F('new'),
    addCompany: () => F('company', 'add'),
    contents: () => F('contents'),
    reportCompany: () => F('report-company'),
    reportType: () => F('report-type'),
    details: () => F('details'),
    readAll: () => F('read-all'),
    reportName: () => F('report-name'),
    reportTitle: () => F('report-title'),
    reportFilename: () => F('report-file-name'),
    addContact: () => F('contact', 'add'),
    name: () => F('name'),
    email: () => F('email'),
    cellPhone: () => F('cell-phone'),
    searchBy: (keys) => F(keys, 'search'),
    contacts: () => F('contacts'),
    save: () => F('save'),
    editContact: (contact) => F('contact', 'edit', contact),
    manageContacts: (contact) => F('manage-contacts'),
    select: (keys) => F(keys, 'select'),
    username: () => F('username'),
    password: () => F('password'),
    signIn: () => F('sign-in'),
    support: () => F('support'),
    copyright: () => F('copyright'),
    version: () => F('version'),
    spudDate: () => F('spud-date'),
    addDate: () => F('add-date'),
    wellAddDate: () => F('well-add-date'),
    filters: () => F('filters'),
    date: () => F('date'),
    entryType: () => F('entry-type'),
    remarks: () => F('remarks'),
    sticky: () => F('sticky'),
    includePendingEntries: () => F('include-pending-entries'),
    dontSendAlerts: () => F('dont-send-alerts'),
    uploadedBy: () => F('uploaded-by'),
    uploadedOn: () => F('uploaded-on'),
    contactInfo: () => F('contact-info'),
    uploadDate: () => F('upload-date'),
    lastEdited: () => F('last-edited'),
    filename: () => F('filename'),
    preserveUploadDate: () => F('preserve-upload-date'),
    files: () => F('files'),
    filesize: () => F('size'),
    approvalStatus: () => F('approval-status'),
    deptOrRole: () => F('dept-or-role'),
    approvedBy: () => F('approved-by'),
    approvalDate: () => F('approval-date'),
    approve: () => F('approve'),
    reject: () => F('reject'),
    undo: () => F('undo'),
    reasonForRejection: () => F('reason-for-rejection'),
    dontLockEntry: () => F('dont-lock-entry'),
    ok: () => F('ok'),
    cancel: () => F('cancel'),
    entryRejection: () => F('entry-rejection'),
    holeDirection: () => F('hole-direction'),
    company: () => F('company'),
    companies: () => F('companies'),
    rig: () => F('rig'),
    rigs: () => F('rigs'),
    asset: () => F('asset'),
    assets: () => F('assets'),
    pad: () => F('pad'),
    pads: () => F('pads'),
    state: () => F('state'),
    field: () => F('field'),
    fields: () => F('fields'),
    country: () => F('country'),
    well: () => F('well'),
    wells: () => F('wells'),
    sourceWell: () => F('source-well'),
    newWellData: () => F('new-well-data'),
    elevation: () => F('elevation'),
    projectedDepth: () => F('projected-depth'),
    departmentOrRole: () => F('department-or-role'),
    template: () => F('template'),
    templates: () => F('templates'),
    approvals: () => F('approvals'),
    approvalSteps: () => F('approval-steps'),
    entryTypeGroup: () => F('entry-type-group'),
    confirm: () => F('confirm'),
    entryHistory: () => F('entry-history'),
    rejectionReason: () => F('rejection-reason'),
    user: () => F('user'),
    users: () => F('users'),
    emailTextSubject: () => F('email-text-subject'),
    emailWithFile: () => F('email-with-file'),
    entries: () => F('entries'),
    upload: () => F('upload'),
    docApprovalEntries: () => F('doc-approval-entries'),
    entryTypeAccess: () => F('entry-type-access'),
    myWellGroups: () => F('my-well-groups'),
    myCompany: () => F('my-company'),
    accessReview: () => F('access-review'),
    entryAudit: () => F('entry-audit'),
    notifications: () => F('notifications'),
    search: () => F('search'),
    docApprovalSearch: () => F('doc-approval-search'),
    report: () => F('report'),
    reports: () => F('reports'),
    allReports: () => F('all-reports'),
    reportsICreated: () => F('reports-i-created'),
    reportsIReceive: () => F('reports-i-receive'),
    myAccount: () => F('my-account'),
    recycleBin: () => F('recycle-bin'),
    help: () => F('help'),
    signOut: () => F('sign-out'),
    saved: () => F('saved'),
    notificationType: () => F('notification-type'),
    text: () => F('text'),
    smsDeliveryMethod: () => F('sms-delivery-method'),
    docApprovalAlertEntryUploaded: () => F('doc-approval-alert-entry-uploaded'),
    docApprovalAlertStep: () => F('doc-approval-alert-step'),
    docApprovalAlertFullyApproved: () => F('doc-approval-alert-fully-approved'),
    docApprovalAlertRejected: () => F('doc-approval-alert-rejected'),
    specificWells: () => F('specific-wells'),
    specificWellGroups: () => F('specific-well-groups'),
    specificRigs: () => F('specific-rigs'),
    specificAssets: () => F('specific-assets'),
    allWells: () => F('all-wells'),
    showEntryTypesWithoutNotifications: () => F('show-entry-types-without-notifications'),
    activeOn: () => F('active-on'),
    wellStage: () => F('well-stage'),
    start: () => F('start'),
    end: () => F('end'),
    highlightRemarksWithinResults: () => F('highlight-remarks-within-results'),
    firstName: () => F('first-name'),
    lastName: () => F('last-name'),
    emailAddress: () => F('email-address'),
    cellCarrier: () => F('cell-carrier'),
    cellPhone: () => F('cell-phone'),
    officePhone: () => F('office-phone'),
    address: () => F('address'),
    city: () => F('city'),
    provinceOrRegion: () => F('province'),
    entriesPerPage: () => F('entries-per-page'),
    groupingPreference: () => F('grouping-preference'),
    wellsPerPage: () => F('wells-per-page'),
    language: () => F('language'),
    currentPassword: () => F('current-password'),
    newPassword: () => F('new-password'),
    confirmPassword: () => F('confirm-password'),
    requestedCompany: () => F('requested-company'),
    requestedAsset: () => F('requested-asset'),
    requestedWellbores: () => F('requested-wellbores'),
    forgotYourPassword: () => F('forgot-your-password'),
    filesPerEntry: () => F('files-per-entry'),
    columns: () => F('columns'),
    pageOptions: () => F('page-options'),
    entryPageOptions: () => F('entry-page-options'),
    saveSearch: () => F('save-search'),
    searchName: () => F('search-name'),
    resetPassword: () => F('reset-password'),
    lockedOut: () => F('locked-out'),
    otherIssues: () => F('other-issues'),
    termsAndConditionsHeader: () => F('terms-and-conditions-header'),
    dropdownKeepOpenOnSelect: () => F('drop-down-keep-open-on-select'),
    columnOptions: () => F('column-options'),
    wellGroup: () => F('well-group'),
    wellGroupName: () => F('well-group-name'),
    editWellGroup: (words) => F('well-group', 'edit', words),
    addWellGroup: () => F('well-group', 'add'),
    sessionExpired: () => F('session-expired'),
    sessionExpiring: () => F('session-expiring'),
    companyOfUser: () => F('company-of-user'),
    role: () => F('role'),
    months: () => F('months'),
    limits: () => F('limits'),
    edit: () => F('edit'),
    edited: () => F('edited'),
    error404Home: () => F('404-home'),
    error404Support: () => F('404-support'),
    drilling: () => F('drilling'),
    completion: () => F('completion'),
    flowback: () => F('flowback'),
    audited: () => F('audited'),
    legalHold: () => F('legalHold'),
    legalHoldYes: () => F('legal-hold-yes'),
    legalHoldNo: () => F('legal-hold-no'),
    legalHoldError: () => F('legal-hold-error'),
    workover: () => F('workover'),
    production: () => F('production'),
    any: () => F('any'),
    resetFilters: () => F('reset-filters'),
    applyFilters: () => F('apply-filters'),
    groupByEntryType: () => F('group-by-entry-type'),
    modifyFiles: () => F('modify-files'),
    reset: () => F('reset'),
    clear: () => F('clear'),
    showAll: () => F('show-all'),
    yes: () => F('yes'),
    no: () => F('no'),
    uploader: () => F('uploader'),
    standard: () => F('standard'),
    showEntryHistory: () => F('show-entry-history'),
    editWell: () => F('well', 'edit'),
    selectAll: () => F('select-all'),
    docApprovalOptions: () => F('doc-approval-options'),
    setMultipleNotifications: () => F('set-multiple-notifications'),
    on: () => F('on'),
    off: () => F('off'),
    add: () => F('add'),
    all: () => F('all'),
    selected: () => F('selected'),
    delete: () => F('delete'),
    deleteAll: () => F('delete-all'),
    download: () => F('download'),
    downloadAll: () => F('download-all'),
    pass: () => F('pass'),
    preview: () => F('preview'),
    restore: () => F('restore'),
    restoreAll: () => F('restore-all'),
    returnOnlyMatchingFiles: () => F('return-only-matching-files'),
    last24Hours: () => F('last-24-hours'),
    lastLogin: () => F('last-login'),
    sendTestEmail: () => F('send-test-email'),
    sendTestMessage: () => F('send-test-message'),
    international: () => F('international'),
    changePassword: () => F('change-password'),
    range: () => F('range'),
    monthsPrevious: () => F('months-previous'),
    'export': () => F('export'),
    subscribe: () => F('subscribe'),
    unsubscribe: () => F('unsubscribe'),
    summary: () => F('summary'),
    actions: () => F('actions'),
    open: () => F('open'),
    close: () => F('close'),
    system: () => F('system'),
    wellHeaderInfo: () => F('well-header-info'),
    more: () => F('more'),
    added: () => F('added'),
    addedBy: () => F('added-by'),
    editDate: () => F('edit-date'),
    editedBy: () => F('edited-by'),
    addReport: () => F('report', 'add'),
    editReport: (words) => F('report', 'edit', words),
    reportSummary: () => F('report-summary'),
    subscribers: () => F('subscribers'),
    subscribed: () => F('subscribed'),
    menu: () => F('menu'),
    troubleSigningIn: () => F('trouble-signing-in'),
    requestAccess: () => F('request-access'),
    scheduleADemo: () => F('schedule-a-demo'),
    learnMore: () => F('learn-more'),
    iAccept: () => F('i-accept'),
    iDontAccept: () => F('i-dont-accept'),
    padName: () => F('pad-name'),
    padNumber: () => F('pad-number'),
    pendingApprovals: () => F('pending-approvals'),
    partners: () => F('partners'),
    auditWell: () => F('auditWell'),
    administrators: () => F('administrators'),
    normal: () => F('normal'),
    template: () => F('template'),
    both: () => F('both'),
    attachedToWell: () => F('attached-to-well'),
    lease: () => F('lease'),
    prospect: () => F('prospect'),
    description: () => F('description'),
    copy: () => F('copy'),
    supplement: () => F('supplement'),
    sectionValues: () => F('section-values'),
    loadFromTemplate: () => F('load-from-template'),
    dryHoleCost: () => F('dry-hole-cost'),
    totalCost: () => F('total-cost'),
    editFiles: () => F('edit-files'),
    saveAsTemplate: () => F('save-as-template'),
    costs: () => F('costs'),
    attachFiles: () => F('attach-files'),
    step: () => F('step'),
    approver: () => F('approver'),
    values: () => F('values'),
    total: () => F('total'),
    note: () => F('note'),
    code: () => F('code'),
    supplementationMethod: () => F('supplementation-method'),
    supplementationAmount: () => F('supplementation-amount'),
    originalResult: () => F('original-result'),
    newResult: () => F('new-result'),
    result: () => F('result'),
    adjust: () => F('adjust'),
    recalculate: () => F('recalculate'),
    globalValues: () => F('global-values'),
    cost: () => F('cost'),
    rounding: () => F('rounding'),
    readyForApproval: () => F('ready-for-approval'),
    backToAfe: () => F('back-to-afe'),
    outputFormat: () => F('output-format'),
    dateRanges: () => F('date-ranges'),
    daysPrevious: () => F('days-previous'),
    currentMonthInclusive: () => F('current-month-inclusive'),
    schedule: () => F('schedule'),
    source: () => F('source'),
    newCompany: () => F('new-company'),
    newEntryType: () => F('new-entry-type'),
    timeSpan: () => F('time-span'),
    hoursPrevious: () => F('hours-previous'),
    wellsWithAllEntryTypes: () => F('wells-with-all-entry-types'),
    appendRunTimeToFileName: () => F('append-run-time-to-file-name'),
    groupBy: () => F('group-by'),
    groupResultsBy: () => F('group-results-by'),
    continue: () => F('continue'),
    unsupportedBrowser: () => F('unsupported-browser'),
    prodData: () => F('prod-data'),
    nonProdData: () => F('non-prod-data'),
    not: () => F('not'),
    updateProfile: () => F('update-profile'),
    exports: () => F('exports'),
    addExport: () => F('export', 'add'),
    prodDataExport: () => F('prod-data-export'),
    prodDataDistribution: () => F('prod-data-distribution'),
    prodDataAccessReview: () => F('prod-data-access-review'),
    distribution: () => F('distribution'),
    allowedDataColumns: () => F('allowed-data-columns'),
    columnName: () => F('column-name'),
    wellProperty: () => F('well-property'),
    timeOfDataDelivery: () => F('time-of-data-delivery'),
    daysOfDataDelivery: () => F('days-of-data-delivery'),
    paused: () => F('paused'),
    active: () => F('active'),
    maintenanceInvoiceSettings: () => F('maintenance-invoice-settings'),
    historical: () => F('historical'),
    disabled: () => F('disabled'),
    noChange: () => F('no-change'),
    includeSoftRejected: () => F('include-soft-rejected'),
    copyAccessUser: () => (`User - Role - Role Type`),
    roles: () => (`Roles`),
    wellAccess: () => (`Well Access`),
    includeTbd: () => F('include-tbd'),
    otherProperties: () => F('other-properties'),
    property: () => F('property'),
    addProperty: () => F('add-property'),
    county: () => F('county'),
    wellAliases: () => F('well-aliases'),
    maintSummary: () => F('maintenance-summary'),
    month: () => F('month'),
    year: () => F('year'),
    lastUploaded: () => F('last-uploaded'),
    changeInWellsSinceLastMonth: () => F('change-in-wells-since-last-month'),
    changeInAssetWellsSinceLastMonth: () => F('change-in-asset-wells-since-last-month'),
    noWellInvoiced: () => F('no-well-invoiced'),
    noMaintInvoiceFound: () => F('no-maintenance-invoice-found'),
    none: () => F('none'),
    totalFileCount: () => F('total-file-count'),
    totalFileSize: () => F('total-file-size'),
    includeLinkToEntry: () => F('include-link-to-entry'),
    check: () => F('check'),
    checkAll: () => F('check-all'),
    home: () => F('home'),
    loginCount: () => F("login-count"),
    phone: () => F('phone'),
    lastUploadDate: () => F('last-upload-date'),
    run: () => F('run'),
    todayOnly: () => F('today-only'),
    hoursBack: () => F('hours-back'),
    latestPerRig: () => F('latest-per-rig'),
    sendMailWhenNoData: () => F('send-mail-when-no-data'),
};